
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapState } from 'vuex';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import Studie from '@/types/Studie';
    import { confirmSwal } from '@/helper/swals';
    import { SweetAlertResult } from 'sweetalert2';
    import { VForm } from '@/types/Components';
    import { SystemEinstellung, SystemEinstellungKey } from '@/types/Einstellung';
    import _ from 'lodash';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('studien', ['studien', 'loaders', 'printers']),
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
        methods: {
            ...mapActions('studien', ['updateStudie', 'deleteStudie', 'loadPrinters']),
        },
    })
    export default class StudienDetail extends Vue {
        @Prop() studie!: Studie;
        @Prop() visible!: boolean;

        public updateStudie!: (studie: Studie) => void;
        public deleteStudie!: (studie: Studie) => void;
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;
        public studien: any;

        public $refs!: {
            form: VForm;
        };

        public get isEdit(): boolean {
            return this.studie.studie_id !== null;
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }
            }
        }

        public onClickSave(): void {
            if (this.$refs.form.validate()) {
                this.updateStudie(this.studie);
            }
        }

        public onClickDelete(): void {
            confirmSwal('Löschen', 'Studie endgültig löschen?', 'Löschen', 'Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.deleteStudie(this.studie);
                    }
                });
        }
    }
